<div class="row content__grid">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box">
      <div class="row align-items-center">
        <div class="col-sm-6 col-md-6 col-sm-6 col-6">
          <h4 class="page-title content__title">Lista traspasos</h4>
        </div>
        <div class="col-sm-6 col-sm-6 col-md-6 col-sm-6 col-6 content__boxBtnHead">
          <ng-container>
            <a routerLink="/{{branchofficeSlug}}/reservas/traspasos/nuevo" class="btn btn-primary">
              <i class="fa fa-plus m-r-5"></i> Crear traspaso </a>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="card content__grid__card">
      <div class="card-body content__grid__cardbody">
        <div class="content__subhead">
          <div class="row">
            <div class="col-lg-7 col-md-7 col-sm-6 col-12 content__subhead__boxBtns">
              <button type="button" class="btn btn-light waves-effect" title="Actualizar" (click)="refresh()">
                <i class="fas fa-undo"></i></button>
              <div class="content__subhead__inputGrid">
                <div class="input-group" style="width: 105%;">
                  <span class="input-group-prepend">
                    <span class="input-group-text content__subhead__inputGrid__title">
                      <i class="far fa-calendar-alt"></i>
                    </span>
                  </span>
                  <input type="text" id="date_range" class="form-control content__subhead__inputGrid__input">
                </div>
              </div>
            </div>
            <div class="col-lg-5 col-md-5 col-sm-6 col-12">
              <component-search (searchEvent)="search($event)"></component-search>
            </div>

          </div>
        </div>
        <div class="content__boxTble">
          <div class="table-responsive">
            <table class="table table-hover mb-0">
              <thead class="thead-default">
                <tr>
                  <th>Código</th>
                  <th>Agencia Traspasado</th>
                  <th class="text-center">Cod.Origen Reserva</th>
                  <th>Programa traspaso</th>
                  <th>Usuario</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="items.length == 0">
                  <td colspan="2"><span>No se encontraron registros</span></td>
                </ng-container>
                <ng-container *ngIf="items.length > 0">
                  <tr
                    *ngFor="let item of items | paginate: { itemsPerPage: dataPagination.pageSize, currentPage: dataPagination.currentPage, totalItems:dataPagination.totalItems }; let i = index">
                    <td>
                      <a style="color: red !important;" class="grid__link" (click)="detail(item.id)">{{item.code}}</a>
                      <p class="bold f-s-10 m-b-0">Reg. :
                        <!-- {{item.created_at | date: 'YYYY-MM-dd'}} -->
                        {{item.created_at | date: 'mediumDate'}}
                      </p>
                    </td>
                    <td>
                      <p class="m-b-0">{{item.agency_data.tradename}}</p>
                      <p class="bold f-s-10 m-b-0">CEL : {{item.agency_data.cellphone}}</p>
                    </td>
                    <td class="text-center">
                      {{item.origintransfer.code}}
                    </td>
                    <td>
                      <p *ngFor="let detail of item.program_transfer" class="m-b-3 f-s-10">
                        <span class="m-r-5"><i class="fas fa-info-circle"></i></span>{{detail.description}}
                        ({{detail.quantity}} pax) <span class="m-l-5">{{detail.date_assigned}}</span>
                      </p>
                    </td>
                    <td >
                      {{item.user_data.username}}
                    </td>
                    <td>
                      <div class="btn-group mo-mb-2" *ngIf="item.is_checkout == false">
                        <button class="btn btn-light btn-dots btn-sm dropdown-toggle" type="button"
                          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          <i class="fas fa-ellipsis-h"></i>
                        </button>
                        <div class="dropdown-menu" x-placement="bottom-start">
                          <a class="dropdown-item pointer" (click)="edit(item.id)">
                            <i class="fas fa-pencil-alt m-r-5 text-success"></i> Editar
                          </a>
                          <ng-container>
                            <a class="dropdown-item pointer" (click)="delete(item, i)">
                              <i class="far fa-trash-alt m-r-5 text-danger"></i>Eliminar
                            </a>
                          </ng-container>
                        </div>
                      </div>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-md-12 ">
          <div class="row content_pagination">
            <div class="col-lg-4">
              <p class="pagination__label">Total <span class="bold">{{dataPagination.totalItems}}</span> registros.</p>
            </div>
            <div class="text-right col-lg-8">
              <ng-container *ngIf="items.length > 0">
                <app-pagination (paginateEvent)="handlePageChange($event)"></app-pagination>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


</div>
